export enum MessageBoxContentTypes {
  Message = 0,
  Info = 1,
  Warning = 2,
  Error = 3
}

export enum MessageBoxStyle {
  Normal = 0,
  Complex = 1
}

export interface MessageBoxContent {
  type: MessageBoxContentTypes;
  style: MessageBoxStyle;
  title: string;
  text: string;
  text2?: string;
  params?: any;
  yesButton: string;
  noButton?: string;
  onPrimarySelected?: CustomSubmit;
  onSecondarySelected?: CustomSubmit;
}

export interface CustomSubmit {
  (): void;
}